import { css, cx } from '@emotion/css';
import { Controller, useFormContext } from 'react-hook-form';

import { UploadButton } from '@/components/button/UploadButton';
import { useStyles } from '@/hooks/useStyles';
import { FileModel, UploadedFileType } from '@/models/FileModel';
import { Patient } from '@/models/PatientModel';
import { Theme } from '@/theme/CreateTheme.ts';

type ControlledFileUploadProps = {
  id?: string;
  name: string;
  fileType: UploadedFileType;
  patientInfo: Pick<Patient, 'givenName' | 'familyName'>;
  defaultValue?: FileModel;
  hasTrash?: boolean;
  displayFilename?: boolean;
  error?: boolean;
};

export const ControlledFileUpload = ({
  id,
  name,
  fileType,
  patientInfo,
  hasTrash = false,
  defaultValue,
  displayFilename,
  error = false,
}: ControlledFileUploadProps) => {
  const styles = useStyles(makeStyles);
  const { control, setValue } = useFormContext();
  const onFileChange = (file?: FileModel) => {
    setValue(name, file);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState }) => (
        <div id={id}>
          <UploadButton
            onFileChange={onFileChange}
            fileType={fileType}
            patientInfo={patientInfo}
            defaultValue={defaultValue}
            hasTrash={hasTrash}
            displayFilename={displayFilename}
            buttonClassName={cx({
              [styles.error]: !!fieldState.error || error,
            })}
          />
        </div>
      )}
    />
  );
};

const makeStyles = (theme: Theme) => ({
  error: css({
    borderColor: theme.palette.error.main,
    borderWidth: 1,
  }),
});
